import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  Box,
  MenuItem,
  Autocomplete,
  List,
  ListItem,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, POST,PUT } from "../Generic/CrudRequest";
import Axios from "../../Utils/Interceptors";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ModalGeneric from "../Generic/ModalGeneric";
import dayjs from "dayjs";
import moment from "moment";
import utc from "dayjs/plugin/utc";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import { useTranslation } from "react-i18next";
import { createRoot } from "react-dom/client";
import Alerts from "../../Utils/Alerts";



export default function Inspections(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchCarga, setSearchCarga] = useState("");
  const [searchVin, setSearchVin] = useState("");
  const [locations, setLocations] = useState([]);
  const [idUbicacion, setIdUbicacion] = useState(0);
  const [fecha, setFecha] = useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = useState(dayjs(new Date()));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [bodyModal, setBodyModal] = useState(null);
  const [inspectionGeneralTypes, setInspectionGeneralTypes] = useState([]);
  const [inspectionGeneralType, setInspectionGeneralType] = useState(0);
  const [pdfData, setPdfData] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState(0);
  const [typeActionModal, setTypeActionModal] = useState(0);
  const fileInputRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState("");
  const [idInspectionSendPdf, setIdInspectionSendPdf] = useState(0);
  const [detail, setDetail] = useState(false);
  const [sendPdf, setSendPdf] = useState(false);
  const theme = useTheme();
  const { config } = props;
  const { t, i18n } = useTranslation();
  dayjs.extend(utc);
  const exportToExcel = useExcelExport();
  const handleExport = () => {
    exportToExcel(rows, columns, t("inspections.actions.titleExcel"));
  };

  const columns = [
  {
    id: "idInspeccionGeneral",
    label: t("inspections.table.inspectionNumber"),
    minWidth: "100px",
  },
  { id: "unidades", label: t("inspections.table.vins"), minWidth: "100px" },
  { id: "cliente", label: t("inspections.table.client"), minWidth: "100px" },
  { id: "noCarga", label: t("inspections.table.loadNumber"), minWidth: "100px" },
  { id: "usuario", label: t("inspections.table.user"), minWidth: "100px" },
  {
    id: "fechaInicio",
    label: t("inspections.table.startDate"),
    minWidth: "100px",
  },
  { id: "fechaFinal", label: t("inspections.table.endDate"), minWidth: "100px" },
  {
    id: "tipoInspeccionGeneral",
    label: t("inspections.table.inspectionType"),
    minWidth: "100px",
  },
  { id: "ubicacionSitio", label: t("inspections.table.location"), minWidth: "100px" },
];

  useEffect(() => {
    fetchInspections();
    fetchGeneralInspectionsType();
  }, [page, rowsPerPage, column, order]);

  // Cargar tipos de inspección al montar el componente
  useEffect(() => {
    fetchGeneralInspectionsType();
  }, []);

  // Escuchar cambios de idioma para recargar los datos
  useEffect(() => {
    const handleLanguageChange = () => {
      // Recargar solo los datos sin recargar toda la página
      fetchInspections();
      fetchGeneralInspectionsType();
    };

    // Agregar listener para el evento de cambio de idioma desde i18n
    i18n.on('languageChanged', handleLanguageChange);

    // Cleanup: remover listener cuando el componente se desmonte
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  useEffect(() => {
    if (pdfData !== "" && fileName !== "" && fileSize !== 0) {
      setIsModalOpen(true);
      setTypeActionModal(2);
      setModalTitle(t("inspections.modal.uploadFile.title"));
      setModalDescription(t("inspections.modal.uploadFile.description"));
      setBodyModal(
        <>
          <Divider sx={{ maxWidth: "100%", margin: "auto", marginTop: 2 }} />
          <Grid item xs={12} marginTop={2}>
            <div
              onDrop={handleFileDrop}
              onDragOver={handleDragOver}
              style={{
                textAlign: "center",
                padding: "3px",
                border: "2px dashed #aaa",
                borderRadius: "4px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
              }}
            >
              <input
                type="file"
                id="file_Documento"
                multiple
                accept="application/pdf"
                onChange={handleFileUpload}
                style={{ display: "none" }}
                ref={fileInputRef}
              />
              {pdfData !== "" ? (
                <Box>
                  <Icons
                    iconName="TextSnippet"
                    fontSize="large"
                    style={{
                      marginBottom: "1px",
                      color: theme.palette.primary.main,
                    }}
                  />
                  <Typography>
                    {fileName} - {fileSize} bytes
                  </Typography>
                </Box>
              ) : (
                <label htmlFor="file_Documento">
                  <div>
                    <Icons
                      fontSize="60px"
                      iconName="CloudUpload"
                      style={{
                        marginBottom: "1px",
                        color: theme.palette.primary.main,
                      }}
                    />
                    <Typography>
                      {t("inspections.modal.uploadFile.dragDrop")}
                    </Typography>
                  </div>
                </label>
              )}
            </div>
          </Grid>
        </>
      );
    }
  }, [pdfData, fileName, fileSize]);

  useEffect(() => {
    if (!isModalOpen) {
      setPdfData("");
      setFileName("");
      setFileSize(0);
      setTypeActionModal(0);
    }
  }, [isModalOpen]);

  const fetchInspections = async () => {
    const vinsSeparated = searchVin.split(/[,\s]+/);
    const filteredVins = vinsSeparated.filter((vin) => vin.trim() !== "");

    const queryParams = new URLSearchParams({
      start: page * rowsPerPage,
      length: rowsPerPage,
      noCarga: searchCarga,
      usuario: user,
      idTipoInspeccion: inspectionGeneralType,
      idUbicacionInspeccion: idUbicacion,
      fechaInicio: fecha.format("MM-DD-YYYY HH:mm:ss"),
      fechaFin: fechaFin.format("MM-DD-YYYY HH:mm:ss"),
      column: column,
      dir: order,
    });

    const dataInspections = await POST(
      `${config.url}/api/GeneralInspections/paginado?${queryParams.toString()}`,
      filteredVins
    );

    setRows(dataInspections.results);
    setTotalRecords(dataInspections.rowCount);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionDetail = searchPermissions(
      "Inspecciones",
      "Detalle",
      permissionsArray
    );

    const permissionSendPDF = searchPermissions(
      "Inspecciones",
      "EnviarPDF",
      permissionsArray
    );

    setDetail(permissionDetail);
    setSendPdf(permissionSendPDF);
  };

  const fetchLocations = async (location, currentPage, perPage) => {
    const dataLocations = await GET(`${config.url}/api/Location/select`, {
      busqueda: location,
      page: currentPage,
      perPage: perPage,
    });

    setLocations(dataLocations.result);
  };

  const fetchUsers = async (user) => {
    const dataUsers = await GET(`${config.url}/api/User/select/${user}`);

    setUsers(dataUsers);
  };

  const fetchGeneralInspectionsType = async () => {
    try {
      const generalInspectionsTypeData = await GET(
        `${config.url}/api/InspectionGeneralType`
      );
      
      // Verificar que la respuesta sea un array válido
      if (Array.isArray(generalInspectionsTypeData)) {
        setInspectionGeneralTypes(generalInspectionsTypeData);
      } else {
        setInspectionGeneralTypes([]);
      }
    } catch (error) {
      setInspectionGeneralTypes([]);
    }
  };

  const sendFilePdf = async () => {
    const archivoDTO = {
      idInspeccionGeneral: idInspectionSendPdf,
      contenidoBase64: pdfData,
    };
    await POST(`${config.url}/api/GeneralInspections/subirarchivo`, archivoDTO);
    fetchInspections();
  };

  const sendjson = async (row) => {
    try {
      var queryParams = new URLSearchParams(
        {
          idInspeccionGeneral:row.idInspeccionGeneral
        });
      await PUT(`${config.url}/api/GeneralInspections/enviarJson?${queryParams.toString()}`);
      
      // Mostrar mensaje de éxito
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={t("inspections.actions.sendInspectionSuccess")}
          type="success"
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );
    } catch (error) {
      // Mostrar mensaje de error
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={t("inspections.actions.sendInspectionError")}
          type="error"
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );
    }
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchInspections();
  };

  const handleClear = () => {
    setSearchCarga("");
    setIdUbicacion(0);
    setLocations([]);
    setSearchVin("");
    setUser("");
    setUsers([]);
    setFecha(dayjs(new Date()));
    setFechaFin(dayjs(new Date()));
    setInspectionGeneralType(0);
    
    // Recargar la información de la tabla después de limpiar los filtros
    fetchInspections();
  };

  const handleInputChange = (event, value) => {
    if (value.trim().length >= 3) {
      fetchLocations(value, 1, 10);
    } else {
      setLocations([]);
    }
  };

  const handleInputChangeUser = (event, value) => {
    if (value.trim().length >= 3) {
      fetchUsers(value);
    } else {
      setUsers([]);
    }
  };

  const handleModalVins = () => {
    setIsModalOpen(true);
    setTypeActionModal(1);
    setModalTitle(t("inspections.modal.searchVins.title"));
    setModalDescription(t("inspections.modal.searchVins.description"));
    setBodyModal(
      <>
        <Divider sx={{ maxWidth: "100%", margin: "auto", marginTop: 2 }} />
        <Grid container spacing={2} marginTop={1}>
          <Grid item xs={12}>
            <TextField type="text" fullWidth id="modalTextField" />
          </Grid>
        </Grid>
      </>
    );
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    handleFile(file);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    const reader = new FileReader();

    reader.onload = async (event) => {
      const binaryString = event.target.result;
      const base64String = btoa(binaryString);
      setPdfData(base64String);
      setFileName(file.name);
      setFileSize(file.size);
    };

    reader.readAsBinaryString(file);
  };

  const handleSubirArchivo = (row) => {
    setPdfData("");
    setFileName("");
    setFileSize(0);
    setIsModalOpen(true);
    setTypeActionModal(2);
    setIdInspectionSendPdf(row.idInspeccionGeneral);
    setModalTitle(t("inspections.modal.uploadFile.title"));
    setModalDescription(t("inspections.modal.uploadFile.description"));
    setBodyModal(
      <>
        <Divider sx={{ maxWidth: "100%", margin: "auto", marginTop: 2 }} />
        <Grid item xs={12} marginTop={2}>
          <div
            onDrop={handleFileDrop}
            onDragOver={handleDragOver}
            style={{
              textAlign: "center",
              padding: "3px",
              border: "2px dashed #aaa",
              borderRadius: "4px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: theme.palette.primary.main,
              },
            }}
          >
            <input
              type="file"
              id="file_Documento"
              multiple
              accept="application/pdf"
              onChange={handleFileUpload}
              style={{ display: "none" }}
              ref={fileInputRef}
            />
            {pdfData !== "" ? (
              <Box>
                <Icons
                  iconName="TextSnippet"
                  fontSize="large"
                  style={{
                    marginBottom: "1px",
                    color: theme.palette.primary.main,
                  }}
                />
                <Typography>
                  {fileName} - {fileSize} bytes
                </Typography>
              </Box>
            ) : (
              <label htmlFor="file_Documento">
                <div>
                  <Icons
                    fontSize="60px"
                    iconName="CloudUpload"
                    style={{
                      marginBottom: "1px",
                      color: theme.palette.primary.main,
                    }}
                  />
                  <Typography>
                    {t("inspections.modal.uploadFile.dragDrop")}
                  </Typography>
                </div>
              </label>
            )}
          </div>
        </Grid>
      </>
    );
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPdfData("");
    setFileName("");
    setFileSize(0);
    setTypeActionModal(0);
  };

  const handleAcceptModal = () => {
    if (typeActionModal === 1) {
      const textFieldValue = document.getElementById("modalTextField").value;
      const vinsString = textFieldValue.replace(/\s+/g, " ").trim();
      setSearchVin(vinsString);

      handleCloseModal();
    } else if (typeActionModal === 2) {
      sendFilePdf();
    }

    handleCloseModal();
  };

  const handleChangeVin = (vin) => {
    setSearchVin(vin);
  };

  const handleDownloadPdf = async (idInspeccionGeneral, fileName) => {
    try {
      // Hacer la petición directamente con axios para evitar el procesamiento del interceptor
      const response = await Axios.post(`${config.url}/api/GeneralInspections/crearPdf?idInspeccionGeneral=${idInspeccionGeneral}`, {}, {
        responseType: 'text' // Especificar que esperamos texto (base64)
      });
      
      const base64 = response.data;
      
      // Verificar que tenemos datos válidos
      if (!base64 || typeof base64 !== 'string') {
        throw new Error('No se recibieron datos válidos del servidor');
      }
      
      // Decodificar base64 a bytes
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      // Crear y descargar el archivo
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      URL.revokeObjectURL(link.href);
      
      // Mostrar mensaje de éxito
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={t("inspections.actions.downloadSuccess")}
          type="success"
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );
    } catch (error) {
      console.error('Error al descargar PDF:', error);
      
      // Mostrar mensaje de error
      const alertElement = document.createElement("div");
      document.body.appendChild(alertElement);
      const root = createRoot(alertElement);
      root.render(
        <Alerts
          error={t("inspections.actions.downloadError")}
          type="error"
          onClose={() => {
            document.body.removeChild(alertElement);
          }}
        />
      );
    }
  };
  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      {isModalOpen && (
        <ModalGeneric
          open={isModalOpen}
          title={modalTitle}
          description={modalDescription}
          onClose={handleCloseModal}
          onAccept={handleAcceptModal}
          bodyComponent={bodyModal}
        />
      )}
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("inspections.title")}
          </Typography>
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.search.load")}
                type="search"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                value={searchCarga}
                onChange={(e) => setSearchCarga(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label={t("inspections.search.vin")}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                value={searchVin}
                onChange={(e) => handleChangeVin(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
                InputProps={{
                  endAdornment: (
                    <Icons
                      iconName="Add"
                      fontSize="small"
                      onClick={() => handleModalVins()}
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={locations}
                noOptionsText={t("noOptions")}
                getOptionLabel={(location) =>
                  `${location.nombre} ${location.descripcion} ${location.ciudad ?? ""
                  } ${location.ubicacionTipo ?? ""}`
                }
                onChange={(event, value) => {
                  if (value) {
                    setIdUbicacion(value.idUbicacion);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.idUbicacion === value.idUbicacion
                }
                onInputChange={handleInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("inspections.search.location")}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("inspections.search.inspectionType")}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                size="small"
                value={inspectionGeneralType}
                onChange={(e) => setInspectionGeneralType(e.target.value)}
                fullWidth
              >
                <MenuItem key={0} value={0}>
                  {t("select")}
                </MenuItem>
                {inspectionGeneralTypes && inspectionGeneralTypes.length > 0 ? (
                  inspectionGeneralTypes.map((tipo) => (
                    <MenuItem
                      key={tipo.idInspeccionGeneralTipo}
                      value={tipo.idInspeccionGeneralTipo}
                    >
                      {tipo.descripcion}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>
                    {t("inspections.search.loadingTypes")}
                  </MenuItem>
                )}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={t("filters.startDate")}
                  value={fecha}
                  fullWidth
                  onChange={(newValue) => {
                    setFecha(dayjs(newValue));
                  }}
                  slots={{
                    textField: (params) => (
                      <TextField variant="standard" fullWidth {...params} />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={t("filters.endDate")}
                  value={fechaFin}
                  fullWidth
                  onChange={(newValue) => {
                    setFechaFin(dayjs(newValue));
                  }}
                  slots={{
                    textField: (params) => (
                      <TextField variant="standard" fullWidth {...params} />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={users}
                noOptionsText={t("noOptions")}
                getOptionLabel={(user) => `${user.nombre}`}
                onChange={(event, value) => {
                  if (value) {
                    setUser(value.idUsuario);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.idUsuario === value.idUsuario
                }
                onInputChange={handleInputChangeUser}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("inspections.search.user")}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("inspections.actions.search")}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
              tooltip={t("inspections.actions.clear")}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t("buttons.exportExcel")}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {t(column.label)}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                  <TableCell />
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t("inspections.table.noData")}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {column.id === "unidades" ? (
                            row.unidades.length > 0 ? (
                              <List>
                                {row.unidades.map((unidad, index) => (
                                  <ListItem key={index}>{unidad.vin}</ListItem>
                                ))}
                              </List>
                            ) : (
                              <i>{t("inspections.table.notAvailable")}</i>
                            )
                          ) : column.id === "fechaInicio" ? (
                            row.fechaInicio !== null ? (
                              <span>
                                {moment
                                  .utc(row.fechaInicio)
                                  .local()
                                  .format("MM/DD/YYYY HH:mm A")}
                              </span>
                            ) : (
                              <i>{t("inspections.table.notAvailable")}</i>
                            )
                          ) : column.id === "fechaFinal" ? (
                            row.fechaFinal !== null ? (
                              <span>
                                {moment
                                  .utc(row.fechaFinal)
                                  .local()
                                  .format("MM/DD/YYYY HH:mm A")}
                              </span>
                            ) : (
                              <i>{t("inspections.table.notAvailable")}</i>
                            )
                          ) : row[column.id] !== null &&
                            row[column.id] !== "" ? (
                            row[column.id]
                          ) : (
                            <i>{t("inspections.table.notAvailable")}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {sendPdf && (
                          <Icons
                            iconName="Send"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            onClick={() => sendjson(row)}
                            tooltip={t("inspections.actions.sendInspection")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {detail && (
                          <Icons
                            iconName="Ballot"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.secondary.main,
                              color: "#fff",
                            }}
                            to={`/Inspecciones/Detalle/${row.idInspeccionGeneral}`}
                            tooltip={t("inspections.actions.details")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {row.archivoNombre === null && sendPdf && (
                          <Icons
                            iconName="UploadFile"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.info.main,
                              color: "#fff",
                            }}
                            onClick={() => handleSubirArchivo(row)}
                            tooltip={t("inspections.actions.uploadFile")}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {row.idInspeccionGeneral !== null && (
                          <Icons
                            iconName="Download"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            onClick={() => handleDownloadPdf(row.idInspeccionGeneral, t("inspections.actions.reportFileName")+"-"+row.idInspeccionGeneral)}
                            tooltip={t("inspections.actions.downloadFile")}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: t("pagination.all") }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("pagination.labelRowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              t("pagination.displayedRows", { from, to, count })
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
